import { useEffect, useRef } from 'react'
import { trackEvent } from '@fs/zion-analytics'
import { useRootsTechBannerContext } from './RootsTechBannerProvider'

export default function useRootsTechBannerAnalytics() {
  const { isOpen, canToggle, analyticsName, finishedPainting, hasExpandedView, hasCollapsedView } =
    useRootsTechBannerContext() || {}
  const expandedAnalyticsTracked = useRef(false)
  const collapsedAnalyticsTracked = useRef(false)
  const mainAnalyticsTracked = useRef(false)

  useEffect(() => {
    if (!finishedPainting) {
      return
    }

    if (!mainAnalyticsTracked.current) {
      trackEvent({
        event_name: `RT_Banner: ${analyticsName}: Viewed`,
      })
      mainAnalyticsTracked.current = true
    }

    if (!expandedAnalyticsTracked.current && ((canToggle && isOpen) || (!canToggle && hasExpandedView))) {
      trackEvent({
        event_name: `RT_Banner: ${analyticsName}: Expanded Viewed`,
      })
      expandedAnalyticsTracked.current = true
    }
    if (!collapsedAnalyticsTracked.current && ((canToggle && isOpen === false) || (!canToggle && hasCollapsedView))) {
      trackEvent({
        event_name: `RT_Banner: ${analyticsName}: Collapsed Viewed`,
      })
      collapsedAnalyticsTracked.current = true
    }
  }, [analyticsName, isOpen, canToggle, finishedPainting, hasExpandedView, hasCollapsedView])
}
